import React from 'react'
import styled from 'styled-components/macro'
import { SearchLoop } from 'assets/svg'
import { TextAvenirNextRegular } from 'modules/common/components/Typography'
import { useBrandingColors } from 'hooks/useBrandingColors'
import { useTranslation } from 'react-i18next'
import { ITheme } from 'styles/types'
import { getScaledValue } from 'utils/scale'

interface IProps {
  onClick?: () => void
  hasGroup?: boolean
  title?: string
  className?: string | undefined
  iconColor?: string
  disabled?: boolean
  showSearchIcon?: boolean
}

const SearchSection: React.FC<IProps> = ({
  onClick,
  hasGroup = true,
  title,
  className,
  iconColor,
  disabled,
  showSearchIcon,
}) => {
  const { icon, text } = useBrandingColors()
  const { t } = useTranslation()

  const getPlaceholder = () => {
    return (
      title || (hasGroup ? t('ADD_MENTION.SELECT_PERSON_GROUP') : t('ADD_MENTION.SELECT_PERSON'))
    )
  }

  return (
    <SearchContainer className={className} onClick={onClick} disabled={disabled}>
      <Placeholder textColor={text}>{getPlaceholder()}</Placeholder>
      {showSearchIcon && (
        <IconWrapper>
          <SearchLoop color={iconColor || icon} />
        </IconWrapper>
      )}
    </SearchContainer>
  )
}

export default SearchSection

const SearchContainer = styled.div<{ disabled?: boolean }>`
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ disabled }) => (disabled ? '' : 'cursor: pointer;')};
  width: 100%;
`

const Placeholder = styled(TextAvenirNextRegular)<{ textColor: string }>`
  color: ${({ textColor }) => textColor};
  font-size: ${getScaledValue(18, 'px')};
  margin-bottom: 0 !important;
  line-height: 1.5;
  @media ${({ theme }: { theme: ITheme }) => theme.breakpoints.sm} {
    font-size: 18px;
    line-height: 1.8;
  }
`

const IconWrapper = styled.div`
  position: absolute;
  top: 4px;
  right: 0px;
  line-height: 0;

  @media ${({ theme }: { theme: ITheme }) => theme.breakpoints.sm} {
    top: 2px;
  }
`
